import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import { MEDIA_TYPE_IMAGE, MEDIA_TYPE_VIDEO } from '../../../config/constants';
import OnImagesLoaded from '../../../../onImagesLoaded';
import MediaModalLoader from '../../loaders/mediaModalLoader';

function MediaModal({ isOpen, media, onClose }) {
  const { t } = useTranslate();

  const [imagesLoaded, setImagesLoaded] = React.useState(false);

  if (!isOpen || !media) return null;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="media-modal"
      contentClassName="media-modal-content bg-dark rounded"
      backdropClassName="media-modal-backdrop"
    >
      <div className="bg-dark d-flex justify-content-between border-0 p-5 align-items-center">
        <i
          className="fas fa-download text-white cursor-pointer"
          onClick={() => {
            const link = document.createElement('a');
            link.href = media.original_asset;
            link.download = media.original_asset;
            link.click();
            link.remove();
          }}
        />
        <button className="btn btn-secondary btn-sm" onClick={onClose}>
          {t('close')}
        </button>
      </div>
      <Modal.Body className="bg-dark d-flex justify-content-center align-items-center">
        {!imagesLoaded && <MediaModalLoader />}

        <OnImagesLoaded onLoaded={() => setImagesLoaded(true)}>
          <div className="d-flex justify-content-center align-items-center">
            {media.media_type === MEDIA_TYPE_IMAGE && (
              <img src={media.original_asset} className="img-fluid mh-500px" />
            )}
            {media.media_type === MEDIA_TYPE_VIDEO && (
              <video controls className="w-100 mh-500px">
                <source src={media.original_asset} type="video/mp4" />
              </video>
            )}
          </div>
        </OnImagesLoaded>
      </Modal.Body>
    </Modal>
  );
}

export default MediaModal;
